import "./admin.jsx";
import "../controllers/admin_scanner";

// Using Inter from rsms.me CDN (loaded in layout) for full OpenType feature support

import "@primer/view-components/app/assets/javascripts/primer_view_components.js"

import "@primer/css/dist/primer.css"
import "@primer/view-components/app/assets/styles/primer_view_components.css"
import "@primer/primitives/dist/css/primitives.css"
import "@primer/primitives/dist/css/functional/themes/light.css"
import "@primer/primitives/dist/css/functional/themes/dark.css"

import "../styles/primer-primitives-overrides.scss";
import "../styles/app-tokens.css";
import "../styles/primer-btn-overrides.scss";
import "../styles/primer-button-overrides.scss";
import "../styles/primer-underline-nav-overrides.scss";
import "../styles/primer-breadcrumbs-overrides.scss";
import "../styles/primer-action-list-overrides.scss";
import "../styles/primer-label-overrides.scss";
import "../styles/primer-banner-overrides.scss";
import "../styles/primer-overlay-overrides.scss";
import "../styles/primer-select-panel-overrides.scss";
import "../styles/primer-form-overrides.scss";
import "../styles/primer-toasts-overrides.scss";
import "../styles/primer-subhead-overrides.scss";
import "../styles/primer-timeline-item-overrides.scss";
import "../styles/primer-menu-overrides.scss";
import "../styles/primer-avatar-overrides.scss";
import "../styles/primer-blankstate-overrides.scss";

import "../styles/custom-layout.scss";
import "../styles/custom-event-card.scss";
import "../styles/custom-integration-card.scss";
import "../styles/custom-card-actions.scss";
import "../styles/custom-form-layout.scss";
import "../styles/custom-feature-card.scss";
import "../styles/custom-list-group.scss";
import "../styles/custom-dashboard-header.scss";
import "../styles/custom-tables.scss";
import "../styles/custom-card.scss";
import "../styles/custom-invoice.scss";
import "../styles/custom-report.scss";
import "../styles/custom-quote-line-items.scss";
import "../styles/custom-quote-concessions.scss";
import "../styles/custom-room-block-strip.scss";
import "../styles/custom-space-needs.scss";
import "../styles/custom-collab-editor.scss";
import "../styles/custom-text-utilities.scss";
import "../styles/custom-calendar.scss";

import "../styles/custom-name-badge-action-overrides.scss";
import "../styles/custom-name-badge-grid.scss";
import "../styles/custom-scanner-overrides.scss";
import "../styles/chakra-theme-overrides.scss";
import "../styles/tiptap-reset.scss";
import "../styles/iubenda-custom.scss";

import "../styles/print-style-overrides.scss";
import "../styles/collapsible-navigation.scss";
import "../styles/custom-permission-chips.scss";
import "../styles/custom-event-log.scss";
import "../styles/custom-facility-preview.scss";
import "../styles/custom-sourcing-map.scss";
import "../styles/account-access.scss";
import "../stylesheets/admin/_app_preview.scss";

import {initMixpanelFromMeta} from "@/components/mixpanelInit";

initMixpanelFromMeta();

// App Preview page navigation
document.addEventListener("click", (e) => {
  const link = e.target.closest("[data-page-url]");
  if (!link) return;
  const iframe = document.getElementById("app-preview-iframe");
  if (!iframe) return;
  e.preventDefault();
  iframe.src = link.dataset.pageUrl;
  document.querySelectorAll("[data-page-url]").forEach((l) => {
    if (l === link) {
      l.setAttribute("aria-current", "page");
    } else {
      l.removeAttribute("aria-current");
    }
  });
});